import React from 'react';
import { Render, Chapter } from '../platformui/';

const ChapterBlock = (props) => {
  return (
    <Chapter
    {...props}
    noToggle={true}
    Heading={Render.Property(props.Heading, 'Heading')}
    StoryPageHeading={props.CurrentPageProps.PageTypeName === 'StoryPage'}
    ContentString={Render.PropertyAsHTML(props.ContentString, 'Content')}
    />
  );
};

export default ChapterBlock;
